import { render, staticRenderFns } from "./peripheralList.vue?vue&type=template&id=8e6b97f6&"
import script from "./peripheralList.vue?vue&type=script&lang=js&"
export * from "./peripheralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports